import React from 'react';
import ReactDOM from 'react-dom';
import MainContainer from './containers/MainContainer';
import { Provider } from 'react-redux';
import createStore from './store/createStore';
import 'react-dates/initialize';
import './styles/main.scss';
import moment from 'moment';
import 'moment/locale/en-gb';
import { addLocaleData, IntlProvider } from 'react-intl';
import enMessages from './static-data/locales/i18n-en';
import createHistory from 'history/createBrowserHistory';
import 'babel-polyfill';

// Store Initialization
// ------------------------------------
const history = createHistory();
const store = createStore(window.__INITIAL_STATE__, history);

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root');

let itLocaleData = require('react-intl/locale-data/it');
let enLocaleData = require('react-intl/locale-data/en');

addLocaleData([itLocaleData, enLocaleData]);

let i18nConfig = {
  locale: 'en',
  messages: enMessages,
};

moment.locale('en');
let render = () => {
  // const MainContainer = require('./components/MainContainer').default
  // const routes = require('./routes/index').default(store)

  ReactDOM.render(
    <Provider store={store}>
      <IntlProvider
        locale={i18nConfig.locale}
        messages={i18nConfig.messages}
      >
        <MainContainer store={store} history={history} />
      </IntlProvider>
    </Provider>,
    MOUNT_NODE
  );
};

window.moment = moment;

render();
